// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.navbar{
    /* border-bottom: solid 1px; */
    box-shadow: darkgrey 1px -5px 20px 0px;
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: +1;
    width: 100%;
}

.navbar-toggler{
    border: none !important;
}

.logoNavBar{
    display: flex;
    gap: 10px;
    font-size: 18px;
    align-items: center;
    padding-left: 10px;
    font-weight: bold;
}

.navbar-brand{
    width: 20% !important;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.AccediBtn{
    background-color: transparent !important;
    border:none;
    color: black;
}

.offcanvas-body button{
    margin-top: 0%;
}

.btnMenu{
    border-radius: 0px;
    background-color: transparent;
    color: black;
    border: none;
    width: 200px;
    border-bottom: 1px solid #f3e4b6;

}

.btnMenu:active{
    border-bottom: 3px solid #f4bc16;
}

.helpbtn{
    background-color: #f4bc16;
    color: black;
    border-radius: 30px;
    font-size: 12px;
    width: -moz-fit-content;
    width: fit-content;
    height: -moz-fit-content;
    height: fit-content;
    border: none !important;
}

.logobtn{
    border: none !important;
    width: -moz-fit-content !important;
    width: fit-content !important;
}
.navbar-nav{
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;

}
.dropdown-menu .show{
    z-index: 2;
}
#dropdown-basic{
    border:none;
    background-color: transparent;
    color: black;
}
.extrainfomenu{
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: space-around;
    flex-direction: row;
}
.navbar-nav .dropdown-menu {
    position: absolute;
}
.dropdown-menu[data-bs-popper] {
    top: 100%;
    left: -50px;
    margin-top: var(--bs-dropdown-spacer);}
.offcanvas-body {
    display: flex;
    gap: 80px;
    flex-grow: 1;
    padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
    overflow-y: auto;
    flex-direction: column;
    align-items: center;
    align-content: center;
    flex-wrap: wrap;}


    @media (min-width: 992px) {
        .navbar-expand-lg .offcanvas .offcanvas-body {
            display: flex;
            flex-direction: row;
            gap: 0px;
            flex-grow: 0;
            padding: 0;
            align-items: end;
            overflow-y: visible;
        }
    }

    @media (min-width: 992px) {
        .navbar-expand-lg .navbar-nav {
            flex-direction: row;
            gap: 0px;
            
        }
        .btnMenu{
            width: 130px;
        }
    }`, "",{"version":3,"sources":["webpack://./src/components/menu/menu.css"],"names":[],"mappings":";AACA;IACI,8BAA8B;IAC9B,sCAAsC;IACtC,eAAe;IACf,QAAQ;IACR,SAAS;IACT,WAAW;IACX,WAAW;AACf;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,wCAAwC;IACxC,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,gCAAgC;;AAEpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,uBAAkB;IAAlB,kBAAkB;IAClB,wBAAmB;IAAnB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,kCAA6B;IAA7B,6BAA6B;AACjC;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;;AAEb;AACA;IACI,UAAU;AACd;AACA;IACI,WAAW;IACX,6BAA6B;IAC7B,YAAY;AAChB;AACA;IACI,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,SAAS;IACT,WAAW;IACX,qCAAqC,CAAC;AAC1C;IACI,aAAa;IACb,SAAS;IACT,YAAY;IACZ,oEAAoE;IACpE,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,qBAAqB;IACrB,eAAe,CAAC;;;IAGhB;QACI;YACI,aAAa;YACb,mBAAmB;YACnB,QAAQ;YACR,YAAY;YACZ,UAAU;YACV,gBAAgB;YAChB,mBAAmB;QACvB;IACJ;;IAEA;QACI;YACI,mBAAmB;YACnB,QAAQ;;QAEZ;QACA;YACI,YAAY;QAChB;IACJ","sourcesContent":["\n.navbar{\n    /* border-bottom: solid 1px; */\n    box-shadow: darkgrey 1px -5px 20px 0px;\n    position: fixed;\n    top: 0px;\n    left: 0px;\n    z-index: +1;\n    width: 100%;\n}\n\n.navbar-toggler{\n    border: none !important;\n}\n\n.logoNavBar{\n    display: flex;\n    gap: 10px;\n    font-size: 18px;\n    align-items: center;\n    padding-left: 10px;\n    font-weight: bold;\n}\n\n.navbar-brand{\n    width: 20% !important;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.AccediBtn{\n    background-color: transparent !important;\n    border:none;\n    color: black;\n}\n\n.offcanvas-body button{\n    margin-top: 0%;\n}\n\n.btnMenu{\n    border-radius: 0px;\n    background-color: transparent;\n    color: black;\n    border: none;\n    width: 200px;\n    border-bottom: 1px solid #f3e4b6;\n\n}\n\n.btnMenu:active{\n    border-bottom: 3px solid #f4bc16;\n}\n\n.helpbtn{\n    background-color: #f4bc16;\n    color: black;\n    border-radius: 30px;\n    font-size: 12px;\n    width: fit-content;\n    height: fit-content;\n    border: none !important;\n}\n\n.logobtn{\n    border: none !important;\n    width: fit-content !important;\n}\n.navbar-nav{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 20px;\n\n}\n.dropdown-menu .show{\n    z-index: 2;\n}\n#dropdown-basic{\n    border:none;\n    background-color: transparent;\n    color: black;\n}\n.extrainfomenu{\n    display: flex;\n    align-content: center;\n    align-items: center;\n    justify-content: space-around;\n    flex-direction: row;\n}\n.navbar-nav .dropdown-menu {\n    position: absolute;\n}\n.dropdown-menu[data-bs-popper] {\n    top: 100%;\n    left: -50px;\n    margin-top: var(--bs-dropdown-spacer);}\n.offcanvas-body {\n    display: flex;\n    gap: 80px;\n    flex-grow: 1;\n    padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);\n    overflow-y: auto;\n    flex-direction: column;\n    align-items: center;\n    align-content: center;\n    flex-wrap: wrap;}\n\n\n    @media (min-width: 992px) {\n        .navbar-expand-lg .offcanvas .offcanvas-body {\n            display: flex;\n            flex-direction: row;\n            gap: 0px;\n            flex-grow: 0;\n            padding: 0;\n            align-items: end;\n            overflow-y: visible;\n        }\n    }\n\n    @media (min-width: 992px) {\n        .navbar-expand-lg .navbar-nav {\n            flex-direction: row;\n            gap: 0px;\n            \n        }\n        .btnMenu{\n            width: 130px;\n        }\n    }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
